import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import 'antd/dist/antd.css';
import 'leaflet/dist/leaflet.css';
import './result.css';
import { LocaleProvider } from 'antd';
import App from './App';
import { BrowserRouter as Router } from "react-router-dom";
import * as serviceWorker from './serviceWorker';
import es_ES from 'antd/lib/locale-provider/es_ES';
import moment from 'moment';
import 'moment/locale/es';
import AuthService from './services/auth.service';

moment.locale('es');

async function checkForAuthStatus() {
  ReactDOM.render(<div>Cargando...</div>, document.getElementById('root'));
  const result = await AuthService.checkCurrentAuth();
  ReactDOM.render(
    <LocaleProvider locale={es_ES}>
      <Router>
        <App route={result ? '' : 'login'} />
      </Router>
    </LocaleProvider>, document.getElementById('root'));
}

checkForAuthStatus().then(() => console.log('ready'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
